import { create } from "zustand";

/** Interface */
export type AppShellLayout = "sidebar" | "topbar";

interface AppShellStore {
	layout: AppShellLayout;
	toggleLayout: () => void;
	setLayout: (layout: AppShellLayout) => void;
	sidebarIsCollapsed: boolean;
	toggleSidebarIsCollapsed: () => void;
	fontScale: number;
	setFontScale: (fontScale: number) => void;
}

export const useAppShellStore = create<AppShellStore>()((set, get) => ({
	layout: (localStorage.getItem("layout") as "sidebar" | "topbar" | null) || "topbar",
	toggleLayout: () => {
		const newLayout = get().layout === "sidebar" ? "topbar" : "sidebar";
		localStorage.setItem("layout", newLayout);
		set(() => ({ layout: newLayout }));
	},
	setLayout: (layout) => {
		localStorage.setItem("layout", layout);
		return set({ layout });
	},
	sidebarIsCollapsed:
		((localStorage.getItem("sidebarIsCollapsed") as "true" | "false" | null) ?? "false") === "true",
	toggleSidebarIsCollapsed: () => {
		const newState = !get().sidebarIsCollapsed;
		localStorage.setItem("sidebarIsCollapsed", newState ? "true" : "false");
		return set(() => ({
			sidebarIsCollapsed: newState,
		}));
	},
	fontScale: Number(localStorage.getItem("font-size-scale")) || 1,
	setFontScale: (fontScale) => {
		localStorage.setItem("font-size-scale", String(fontScale));
		return set({ fontScale });
	},
}));
